import { FontsType, styled } from '@openeducation/oe-it-themes';
import { rgba } from 'polished';
import React from 'react';

import { OEText, OETextProps } from '../../atoms/oe-text/oe-text';

type OETagType =
  | 'primary'
  | 'primaryLight'
  | 'primaryDark'
  | 'primaryGhost'
  | 'accent'
  | 'yellow'
  | 'white';

export interface OETagProps extends OETextProps {
  type?: OETagType;
  fontType?: keyof FontsType;
  children: string;
}

export const OETag: React.FC<OETagProps> = ({
  type = 'primary',
  fontType = 'light',
  children,
  ...rest
}) => {
  return (
    <Tag fontType={fontType} type={type} {...rest}>
      {children}
    </Tag>
  );
};

interface TagProps {
  type: OETagType;
}

const Tag = styled(OEText)<TagProps>`
  overflow: hidden;
  letter-spacing: 1px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
  background-color: ${({ type, theme }) => {
    const colors = {
      white: theme.color.white,
      primary: theme.color.primary,
      accent: theme.color.accent,
      yellow: theme.color.yellow,
      primaryLight: rgba(theme.color.primary, 0.1),
      primaryGhost: theme.color.white,
      primaryDark: theme.color.secondaryPacificBlueDark,
    } as const;

    return colors[type];
  }};
  color: ${({ type, theme }) => {
    const colors = {
      white: theme.color.dark1,
      primary: theme.color.white,
      accent: theme.color.white,
      yellow: theme.color.dark1,
      primaryLight: theme.color.dark1,
      primaryGhost: theme.color.primary,
      primaryDark: theme.color.white,
    } as const;

    return colors[type];
  }};
`;
